import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'

import { PageAnimations } from '@/animations'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <>
            <Navbar />

            <main>
                {children}
            </main>

            <Footer />

            <PageAnimations />
        </>
    )
}
